import { createSlice } from "@reduxjs/toolkit";
import filter from "lodash/filter";
import map from "lodash/map";

export const cartSlice = createSlice({
  name: "cart",
  initialState: {
    cart: [],
  },
  reducers: {
    addProduct: (state, action) => {
      const array = [...state.cart, action.payload];
      const tempObj = {};

      array.forEach((item) => {
        const productId = item?.product?._id;
        if (tempObj[productId]) {
          tempObj[productId].quantity += item?.quantity;
        } else {
          tempObj[productId] = { ...item };
        }
      });

      const mergedArray = Object.values(tempObj);

      state.cart = [...mergedArray];
    },
    removeProduct: (state, action) => {
      state.cart = filter(state.cart, (item) => item?.product?._id !== action.payload);
    },
    updateProduct: (state, action) => {
      state.cart = map(state.cart, (item) => {
        if (item?.product?._id === action.payload?.product?._id) {
          item.quantity = action.payload?.quantity;
        }
        return item;
      });
    },

    // Cập nhật giá/tồn kho theo máy chủ (POST /product/cart-prices hoặc lỗi 409 khi đặt hàng).
    // payload: [{ productId, unitPrice, salePrice, stock, flash, status }]
    syncPrices: (state, action) => {
      const byId = new Map((action.payload ?? []).map((it) => [String(it?.productId), it]));
      state.cart = map(state.cart, (item) => {
        const it = byId.get(String(item?.product?._id));
        if (!it) return item;
        if (it.status === "not_found" || it.status === "stopped" || it.status === "out_of_stock") {
          return { ...item, product: { ...item.product, unavailable: it.status } };
        }
        const product = { ...item.product, unavailable: null };
        if (it.unitPrice > 0) product.discountPrice = it.unitPrice;
        if (it.salePrice > 0) product.salePrice = it.salePrice;
        if (Number.isFinite(it.stock)) product.stock = it.stock;
        const quantity = it.status === "over_stock" && it.stock > 0 ? Math.min(item.quantity, it.stock) : item.quantity;
        return { ...item, product, quantity };
      });
    },

    deleteProduct: (state) => {
      state.cart = [];
    },
  },
});

export const { addProduct, removeProduct, updateProduct, syncPrices, deleteProduct } = cartSlice.actions;

export default cartSlice.reducer;
